import { Injectable, signal } from "@angular/core";
import { Subject, Observable } from 'rxjs';

import { BreadcrumbItem } from "../types/breadcrumbitem";
import { AppFeatureEnum } from '../types';

@Injectable({
    "providedIn": "root"
})
export class BreadcrumbService2 {
    private $crumbsSignal = signal<BreadcrumbItem[]>([]);
    public $crumbs = this.$crumbsSignal.asReadonly();
    lastAppFeature: AppFeatureEnum;

    private $hideBreadcrumbSignal = signal<boolean>(false);
    public $hideBreadcrumb = this.$hideBreadcrumbSignal.asReadonly();

    constructor() {
        //Get breadcrumb from localStorage
        this.getBreadcrumbFromLocalStorage();
    }

    getCrumb(title: string) {
        return this.$crumbs().find((m: BreadcrumbItem) => m.title === title);
    }

    setCrumbs(item: BreadcrumbItem, reset: boolean = false, hide: boolean = false) {
        //by default show the global breadcrumb in case it was hidden by a previous component
        this.setHideBreadcrumb(hide);

        //Get breadcrumb from localStorage
        this.getBreadcrumbFromLocalStorage();
        this.lastAppFeature = item.appKey;

        if (reset) {
            this.$crumbsSignal.set([]);
        }

        let titleExists: BreadcrumbItem = this.$crumbs().find((m: BreadcrumbItem) => m.title === item.title);        
        let index: number = this.$crumbs().findIndex((m: BreadcrumbItem) => m.title === item.title);

        //If a breadcrumb with the same title but a different routerlink is in arrayCrumbs, remove it and add the new one with the new routerLink
        if (titleExists) {            
            //remove any breadcrumbs that come after an existing crumb with the same title as the crumb we are adding
            this.$crumbsSignal.set(this.$crumbs().slice(0, index));            

            //add the breadcrumb with the new routerLink (ie. path)
            this.$crumbsSignal.set([...this.$crumbs(), item]);
        } else {
            //If no breadcrumb exists for this title add it to arrayCrumbs
            this.$crumbsSignal.set([...this.$crumbs(), item]);
        }

        //Save breadcrumb in localStorage
        sessionStorage.setItem("breadcrumb", JSON.stringify(this.$crumbs()));
    }

    setHideBreadcrumb(hide: boolean) {
        this.$hideBreadcrumbSignal.set(hide);
    }

    setMultipleCrumbs(items: BreadcrumbItem[], reset: boolean = false) {
        //Get breadcrumb from localStorage
        this.getBreadcrumbFromLocalStorage();
        this.lastAppFeature = items[0].appKey;

        if (reset) {
            this.$crumbsSignal.set([]);
        }

        this.$crumbsSignal.set([...this.$crumbs(), ...items]);

        //Save breadcrumb in localStorage
        sessionStorage.setItem("breadcrumb", JSON.stringify(this.$crumbs()));
    }

    getBreadcrumbFromLocalStorage() {
        //Get breadcrumb from localStorage
        const arrayCrumbsJSON = sessionStorage.getItem("breadcrumb");
        if (arrayCrumbsJSON) {
            this.$crumbsSignal.set(JSON.parse(arrayCrumbsJSON));            
        }
    }
}
